import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { LocationSectorApi } from '../../../../core/api/location-sectors/location-sectors.api';


export const locationSectorNameUniqueAsyncValidator = ({ locationSectorApi, locationId, sectorId }: {
  locationSectorApi: LocationSectorApi,
  locationId: string,
  sectorId: string
}) => {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const name = control.value;

    return timer(500)
      .pipe(
        switchMap(() => locationSectorApi.search({
          where: {
            nameEq: name,
            locationId: locationId
          },
          limit: 1,
          offset: 0,
        })),
        map(({ items }) => {
          return items.some((item) => item.id !== sectorId)
            ? { nameAlreadyExists: true }
            : null;
        })
      );
  };
};
